var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.nested.length)?_c('div',{staticClass:"nested",class:{'is-active': true}},_vm._l((_vm.nested),function(subitem){return _c('app-view-sheet-item',{key:subitem.id,attrs:{"is-condensed":true,"is-sticky":_vm.isSticky,"item":subitem,"fields":_vm.fields,"filter":_vm.filter,"grid":_vm.grid}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }